import { Component } from '@angular/core';
import { FormFlow, PgFormField, PgFormGroup, PgFormLayout } from '../../../models/form.model';
import { ConfigFormLayoutGroupField } from '../../../models/config.resources.model';
import { StepFormBase } from '../step-form-base';
import { StepFormSupplierCommon } from '../step-form-supplier-common';

@Component({
    selector: 'app-forms-eatery',
    templateUrl: './forms-eatery.component.html',
    styleUrls: ['./forms-eatery.component.scss'],
    standalone: false
})
export class FormsEateryComponent extends StepFormBase {

    formId = 'eatery';
    resourceId = 'Eatery';

    _currencyOptions:Array<{ value:string, text: string }> = null;
    _currencyDefault:string = null;

    createFormFlow() {
        this._currencyOptions = this.optionMapsService.getFixedOptionMap('*', 'currency')
        this._currencyDefault = this.environmentService.getDefaultCurrency();

        return new FormFlow({
            'dati_generali': {
                title: null,
                form: StepFormSupplierCommon.getGeneralDataFormLayout(this.formId, this.resourceId, this.localizationService, this.environmentService)
            },
            'descrizione': {
                title: null,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'bookable', default: false }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'booking', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'type' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'secondary_categories', multi: true,
                        optionsFilter: [
                            { field: 'value', operator: '!=', value: [ '{{$form.type}}' ]}
                        ]
                    }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'cuisine_type', multi: true }),
                    new PgFormField({ label: 'auto', type: 'html', name: 'description@EateryTranslation', required: true, locale: true, maxLength: 350 }),
                    new PgFormField({ label: 'auto', type: 'html', name: 'special_dishes@EateryTranslation', locale: true }),
                    new PgFormField({ label: '', type: 'timetable-openings', name: 'availability', multi: true })
                ])
            },
            'servizi': {
                title: null,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'select', multi: true, name: 'general_services' }),
                    new PgFormField({ label: 'auto', type: 'select', multi: true, name: 'diet_and_allergies', useKeys: true }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'family_friendly' }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'pet_friendly' })
                ])
            },
            'menu': {
                title: null,
                description: 'auto',
                multi: 'menu',
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'string', name: 'menu_name', locale: true }),
                    new PgFormField({ label: 'auto', type: 'html', name: 'menu_description', locale: true }),
                    new PgFormField({ label: 'auto', type: 'decimal', name: 'menu_price' }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'menu_price_unit', options: this._currencyOptions, default: this._currencyDefault, tooltip: 'auto' }),
                ])
            },
            'file': {
                title: null,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'info', name: 'images_rights', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: false, fileType: 'images', name: 'logo' }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'menu_link' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, name: 'menu_file' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'videos', name: 'videos' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'images', name: 'images' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'images', name: 'images_outside' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'images', name: 'images_bar' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'images', name: 'images_hall' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'images', name: 'images_dishes' })
                ])
            },
            'survey': {
                title: null,
                description: 'auto',
                form: new PgFormLayout([
                    new PgFormField({ label: '', type: 'survey', name: 'survey', locale: true }),
                ])
            }
        })
    }

    customizeFormFlow() {
        this.formFlow.states['descrizione'].form.getFieldLayout('bookable').display = { fullWidth: false }
        this.formFlow.states['descrizione'].form.getFieldLayout('booking').condition = '$form.bookable';

        this.formFlow.states['descrizione'].form.getFieldLayout('secondary_categories').display = { oneLine: true }
    }

    async afterInit() {
        if(this.environmentService.getApplicationURL('Checkout') != null) {
            let _id = this.elementId;
            if(this.dataService.isDraftId(_id)) _id = 'id';

            this.formFlow.states['descrizione'].form.getFieldByName('booking').placeholder = this.environmentService.getApplicationURL('Checkout') + '/book-eatery/' + _id;
        }
        else {
            this.formFlow.states['descrizione'].form.getFieldByName('booking').placeholder = null;
        }
    }

    mapImportData(data:google.maps.places.PlaceResult) {
        return StepFormSupplierCommon.mapImportData(data)
    }

    adaptLoadData(values:any) {
        this._lastTimezone = null;

        return super.adaptLoadData(values);
    }

    adaptSaveData(values:any) {
        values = super.adaptSaveData(values);

        if(values.booking == '') values.booking = null;

        return values;
    }

    onValuesChange(data) {
        super.onValuesChange(data);

        this._checkTimezone(data);
    }

    private _lastTimezone = null;

    _checkTimezone(data) {
        if(data.timezone != this._lastTimezone) {
            this._lastTimezone = data.timezone;

            this.formFlow.states.descrizione.form.getFieldByName('availability').timezone = data.timezone;
        }
    }
}
